import { render, staticRenderFns } from "./PaymtDocNoHelpList.vue?vue&type=template&id=2d51b187&"
import script from "./PaymtDocNoHelpList.vue?vue&type=script&lang=js&"
export * from "./PaymtDocNoHelpList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports